import styled from "@emotion/styled";
import { arrayOf, bool, number, shape, string } from "prop-types";
import React, { useState } from "react";

import theme from "../../theme";
import Heading from "../Heading";
import AccordionItem, { AccordionItemType } from "./components/AccordionItem";

const StyledHeading = styled(Heading)`
  margin-bottom: ${theme.spacing("s")};
`;

const Accordion = ({ title, items, showNumbers, selected = null }) => {
  const [selectedItem, setSelectedItem] = useState(selected);

  return (
    <>
      {title && <StyledHeading size={2}>{title}</StyledHeading>}
      {items.map((item, i) => (
        <AccordionItem
          key={`item-${i}`}
          id={i}
          selected={selectedItem}
          setSelected={setSelectedItem}
          showNumber={showNumbers}
          {...item}
        />
      ))}
    </>
  );
};

Accordion.propTypes = {
  title: string,
  items: arrayOf(shape(AccordionItemType)),
  selected: number,
  showNumbers: bool,
};

Accordion.defaultProps = {
  selected: null,
};

export default Accordion;
